import React from "react";
import "./SignPdfFinishPopdown.css";

/**
 * Compact finish menu — download, print, share (rail + left panel).
 */
const SignPdfFinishPopdown = ({
  disabled = false,
  busy = false,
  shareSupported = false,
  onDownload = () => {},
  onDownloadLater = () => {},
  onPrint = () => {},
  onEmailPdf = () => {},
  onShare = () => {},
}) => (
  <div className="sp-finish-popdown" role="menu">
    <p className="sp-finish-popdown__title">Your document</p>
    <div className="sp-finish-popdown__actions">
      <button
        type="button"
        className="sp-finish-popdown__btn sp-finish-popdown__btn--primary"
        disabled={disabled || busy}
        onClick={onDownload}
      >
        Download PDF
      </button>
      <button
        type="button"
        className="sp-finish-popdown__btn"
        disabled={disabled || busy}
        onClick={onDownloadLater}
      >
        Download later
      </button>
      <button
        type="button"
        className="sp-finish-popdown__btn"
        disabled={disabled || busy}
        onClick={onPrint}
      >
        Print
      </button>
      <button
        type="button"
        className="sp-finish-popdown__btn"
        disabled={disabled || busy}
        onClick={onEmailPdf}
      >
        Email PDF
      </button>
      {shareSupported ? (
        <button
          type="button"
          className="sp-finish-popdown__btn"
          disabled={disabled || busy}
          onClick={onShare}
        >
          Share
        </button>
      ) : null}
    </div>
  </div>
);

export default SignPdfFinishPopdown;
